import _get from 'lodash/get';

export default function createProductsData(data) {
  const products = _get(data, 'products.results', []);
  const productVariants = _get(data, 'productVariants', []);
  const blockedVariants = _get(data, 'blockedVariants', {});

  const varaintsMap = productVariants.reduce((acc, variant) => {
    const id = _get(variant, 'objectID');
    const productId = _get(variant, 'product.id');
    variant.exception = _get(blockedVariants, id, null);
    if (!(productId in acc)) {
      acc[productId] = [];
    }
    acc[productId].push(variant);
    return acc;
  }, {});

  return products.map(product => {
    const data = _get(product, '_source', {});
    const productId = _get(data, 'ObjectId', '');
    data.productVariants = _get(varaintsMap, productId, []);
    return data;
  });
}
